import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEdit, FaTrash } from "react-icons/fa";
import { Container, Card, Button } from "react-bootstrap";
import { getStaff, deleteStaff } from "../../store/slices/staff";
import { useDispatch, useSelector } from "react-redux";
import DeleteModal from "./deletepopup";

export default function Staff() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { staffList = [], loading } = useSelector((state) => state.staff);

  const [showDelete, setShowDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteStatus, setDeleteStatus] = useState("confirm");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // handledelete
  const handleConfirmDelete = async () => {
    try {
      setDeleteStatus("loading");

      await dispatch(deleteStaff(selectedId)).unwrap();

      setDeleteStatus("success");

      setTimeout(() => {
        setShowDelete(false);
        setDeleteStatus("confirm");
      }, 1500);
    } catch (error) {
      setDeleteStatus("confirm");
    }
  };

  useEffect(() => {
    dispatch(getStaff());
  }, [dispatch]);

  const totalPages = Math.ceil(staffList.length / itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = staffList.slice(indexOfFirstItem, indexOfLastItem);

  const changePage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span
            className="breadcrumb-link inactive"
            onClick={() => navigate("/admin/staff")}
          >
            Staff
          </span>
        </div>

        <button
          className="add-outlet-btn"
          onClick={() => navigate("/admin/addstaff")}
        >
          + Add Staff
        </button>
      </div>

      <Container fluid>
        <Card className="table-border">
          <Card.Body>
            <div className="guests-table-wrapper common-table-wrapper">
              <table className="table guests-table common-table align-middle">
                <thead>
                  <tr>
                    <th className="text-center">#</th>
                    <th className="text-center">Name</th>
                    <th className="text-center">Mobile Number</th>
                    <th className="text-center">Email</th>
                    <th className="text-center">Designation</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading
                    ? [...Array(6)].map((_, index) => (
                      <tr key={index}>
                        <td className="text-center">
                          <div className="skeleton skeleton-text small"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-text"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-text"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-text"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-text"></div>
                        </td>

                        <td className="text-center">
                          <div className="action-btn-group d-flex justify-content-center gap-2">
                            <div className="skeleton skeleton-btn"></div>
                            <div className="skeleton skeleton-btn"></div>
                          </div>
                        </td>
                      </tr>
                    ))
                    : currentItems?.map((staff, index) => (
                      <tr key={staff._id}>
                        <td className="text-center">
                          {indexOfFirstItem + index + 1}
                        </td>

                        <td className="text-center">{staff.name}</td>

                        <td className="text-center">{staff.mobileNumber}</td>

                        <td className="text-center">{staff.email}</td>

                        <td className="text-center">{staff.designation}</td>

                        <td className="text-center">
                          <div className="action-btn-group">
                            <button
                              onClick={() =>
                                navigate(`/admin/editstaff/${staff._id}`)
                              }
                              className="action-btn edit-btn"
                            >
                              <FaEdit size={14} />
                            </button>

                            <button
                              className="action-btn delete-btn"
                              onClick={() => {
                                setSelectedId(staff._id);
                                setShowDelete(true);
                              }}
                            >
                              <FaTrash size={14} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

            {totalPages > 1 && (
              <div className="d-flex justify-content-end mt-3 gap-2">
                <button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => changePage(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="previous-btn"
                >
                  Prev
                </button>

                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i}
                    size="sm"
                    variant={
                      currentPage === i + 1 ? "primary" : "outline-secondary"
                    }
                    onClick={() => changePage(i + 1)}
                  >
                    className=
                    {`button-between ${currentPage === i + 1 ? "active-page" : ""
                      }`}
                    {i + 1}
                  </button>
                ))}

                <button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => changePage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="next-btn"
                >
                  Next
                </button>
              </div>
            )}
          </Card.Body>
        </Card>
      </Container>
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onConfirm={handleConfirmDelete}
        status={deleteStatus}
      />
    </>
  );
}
